// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-slider-swiper-slide-slide-eqwhh{flex-shrink:0;height:100%;position:relative;transition-property:transform;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide": "components-slider-swiper-slide-slide-eqwhh"
};
module.exports = ___CSS_LOADER_EXPORT___;
